<template>
  <el-popover
    placement="top-end"
    popper-class="tip-popper-container"
    :trigger="trigger"
    :width="width"
  >
    <slot />
    <fps-icon slot="reference" class="reverse-y" type="warning-inline" size="18" color="#636D86" />
  </el-popover>
</template>
<script>
export default {
  props: {
    width: {
      type: String,
      default: '280'
    },
    trigger: {
      tpye: String,
      default: 'hover'
    }
  },
  data() {
    return {}
  },
  created() {

  },
  methods: {

  }
}
</script>
<style lang="scss">
  .tip-popper-container {
    padding: 0;
  }
</style>
<style lang="scss" scoped>
  .reverse-y {
    display: block;
    transform: scaleY(-1);
    opacity: .5;
  }
</style>
